import {
  CommentActionType,
  GetCommentsStartAction,
  GetCommentsSuccessAction,
  GetCommentsFailureAction,
  SaveCommentStartAction,
  SaveCommentSuccessAction,
  SaveCommentFailureAction,
  DeleteCommentStartAction,
  DeleteCommentSuccessAction,
  DeleteCommentFailureAction,
  AddUserToCommentAction,
  RemoveUserFromCommentAction,
  ClearUsersAction
} from './comments.actions';
import { createReducer } from '@common/redux-utils';
import { CommentViewModel } from '@models/Comment';
import { OptionsViewModel } from '@models/common.models';

// Defining the state of the page.
// Should be one per page.
// All properties should be readonly.
export interface CommentState {
  readonly message?: string;
  readonly query?: string | null;
  readonly commentsLoading?: boolean;
  readonly commentsPageCount?: number;
  readonly commentsPageNumber?: number;
  readonly commentsPageSize?: number;
  readonly commentsOrderBy?: string;
  readonly comments?: CommentViewModel[];
  readonly commentVM: CommentViewModel | null;
  readonly usersToAction: Array<OptionsViewModel>;
}

// This is the initial state of the page
const initialState: CommentState = {
  message: '',
  query: '',
  commentsLoading: false,
  commentsPageCount: 0,
  commentsPageNumber: 1,
  comments: [],
  commentsPageSize: 10,
  commentsOrderBy: 'id',
  commentVM: null,
  usersToAction: []
};

/********** Search **********/
function handleGetCommentsStart(state: CommentState, action: GetCommentsStartAction): CommentState {
  return {
    ...state,
    message: 'Search Init',
    query: action.query,
    commentsLoading: true
  };
}

function handleGetCommentsSuccess(state: CommentState, action: GetCommentsSuccessAction): CommentState {
  return {
    ...state,
    message: 'Search Success!',
    commentsLoading: false,
    commentsPageCount: Math.ceil(action.result.totalResults / action.result.pageSize),
    commentsPageNumber: action.pageNumber,
    commentsPageSize: action.pageSize,
    commentsOrderBy: action.orderBy,
    comments: action.result.results
  };
}

function handleGetCommentsFailure(state: CommentState, action: GetCommentsFailureAction): CommentState {
  return {
    ...state,
    message: action.errorMessage,
    commentsLoading: false
  };
}

/******* Save  ******/
function handleSaveCommentStart(state: CommentState, action: SaveCommentStartAction): CommentState {
  return {
    ...state,
    message: action.message
  };
}

function handleSaveCommentSuccess(state: CommentState, action: SaveCommentSuccessAction): CommentState {
  return {
    ...state,
    message: action.message
  };
}

function handleSaveCommentFailure(state: CommentState, action: SaveCommentFailureAction): CommentState {
  return {
    ...state,
    message: action.errorMessage || ''
  };
}

/******* Save  ******/
function handleDeleteCommentStart(state: CommentState, action: DeleteCommentStartAction): CommentState {
  return {
    ...state,
    message: action.message
  };
}

function handleDeleteCommentSuccess(state: CommentState, action: DeleteCommentSuccessAction): CommentState {
  return {
    ...state,
    comments: state.comments!.filter(comment => comment.commentId !== action.commentId),
    message: action.message
  };
}

function handleDeleteCommentFailure(state: CommentState, action: DeleteCommentFailureAction): CommentState {
  return {
    ...state,
    message: action.errorMessage || ''
  };
}

function handleAddUser(state: CommentState, action: AddUserToCommentAction): CommentState {
  const userToAdd = { id: action.user.id, value: action.user.email };

  return {
    ...state,
    usersToAction: [...state.usersToAction, userToAdd]
  };
}

function handleRemoveUser(state: CommentState, action: RemoveUserFromCommentAction): CommentState {
  return {
    ...state,
    usersToAction: state.usersToAction.filter(user => user.value !== action.userEmail)
  };
}

function handleClearUsers(state: CommentState, action: ClearUsersAction): CommentState {
  return {
    ...state,
    usersToAction: []
  };
}

// This creates the reducer as redux wants it w/ a helper function
// There should an entry for each action type
export const CommentReducer = createReducer(initialState, {
  /********** Search **********/
  [CommentActionType.GetCommentsStart]: handleGetCommentsStart,
  [CommentActionType.GetCommentsSuccess]: handleGetCommentsSuccess,
  [CommentActionType.GetCommentsFailure]: handleGetCommentsFailure,

  /****** Save **************/
  [CommentActionType.SaveCommentStart]: handleSaveCommentStart,
  [CommentActionType.SaveCommentSuccess]: handleSaveCommentSuccess,
  [CommentActionType.SaveCommentFailure]: handleSaveCommentFailure,

  /********* Delete *********/
  [CommentActionType.DeleteCommentStart]: handleDeleteCommentStart,
  [CommentActionType.DeleteCommentSuccess]: handleDeleteCommentSuccess,
  [CommentActionType.DeleteCommentFailure]: handleDeleteCommentFailure,

  [CommentActionType.AddUserToComment]: handleAddUser,
  [CommentActionType.RemoveUserFromComment]: handleRemoveUser,
  [CommentActionType.ClearUsers]: handleClearUsers
});



// WEBPACK FOOTER //
// ./src/comments/comments.reducer.ts